<template>
  <div class="hospital-selector">
    <!-- 搜索框 -->
    <van-search v-model="searchText" placeholder="搜索医院" @input="onSearch" />
    <!-- 医院列表 -->
    <van-index-bar :sticky="false" :index-list="indexList">
      <div v-for="group in filteredHospitalGroups" :key="group.letter">
        <van-index-anchor :index="group.letter" />
        <van-cell
          v-for="(hospital, index) in group.data"
          :key="index"
          :title="hospital"
          @click="selectHospital({item: hospital})"
        />
      </div>
    </van-index-bar>

    <!-- 底部链接 -->
    <div class="link" @click="addCustomHospital">医院不在列表中？</div>
  </div>
</template>

<script>
import { pinyin } from 'pinyin-pro'; // 引入 pinyin-pro
import { getInstitutionsByCity } from '@/api/live';
import { Search, IndexBar, IndexAnchor, Cell } from 'vant';

export default {
  components: {
    [Search.name]: Search,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
  },
  props: {
    city: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      hospitals: [],
      hospitalGroups: [],
      searchText: '',
      polyphonicMap: {
        重: 'C',
        长: 'C',
        乐: 'L',
      },
    };
  },

  computed: {
    indexList() {
      return this.hospitalGroups.map((group) => group.letter);
    },

    filteredHospitalGroups() {
      if (!this.searchText) {
        return this.hospitalGroups;
      }

      return this.hospitalGroups
        .map((group) => ({
          letter: group.letter,
          data: group.data.filter((hospital) =>
            hospital.toLowerCase().includes(this.searchText.toLowerCase())
          ),
        }))
        .filter((group) => group.data.length > 0);
    },
  },

  watch: {
    city(newCity) {
      if (newCity) {
        this.fetchHospitals(newCity);
      }
    },
  },

  created() {
    this.fetchHospitals(this.city);
  },

  methods: {
    fetchHospitals(city) {
      getInstitutionsByCity(city).then((res) => {
        this.updateHospitals(res.value);
      });
    },

    updateHospitals(hospitals) {
      this.hospitals = hospitals;
      this.groupHospitalsByPinyin();
    },

    groupHospitalsByPinyin() {
      const groups = {};

      this.hospitals.forEach((hospital) => {
        const firstChar = hospital.institution_name[0];
        console.log('first', pinyin(firstChar, { toneType: "none" }));
        let firstLetter =
          this.polyphonicMap[firstChar] ||
          pinyin(firstChar, { toneType: "none" })[0].toUpperCase();

        // 如果首字母不是英文字母，回退到默认值 "#"
        if (!/^[A-Z]$/.test(firstLetter)) {
          firstLetter = '#';
        }

        if (!groups[firstLetter]) {
          groups[firstLetter] = [];
        }
        groups[firstLetter].push(hospital.institution_name);
      });

      this.hospitalGroups = Object.keys(groups)
        .sort()
        .map((letter) => ({
          letter,
          data: groups[letter],
        }));
    },

    selectHospital(e) {
      this.$emit('select', e.item);
    },

    addCustomHospital() {
      this.$emit('addCustom');
    },

    onSearch() {
      // 搜索功能通过计算属性 filteredHospitalGroups 实现
    },
  },
};
</script>

<style lang="scss" scoped>
.hospital-selector {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f2f5f9;
}

.link {
  color: #1989fa;
  cursor: pointer;
  padding: 16px;
  text-align: center;
  font-size: 14px;
  border-top: 1px solid #ebedf0;
}

// 调整索引栏样式
:deep(.van-index-bar) {
  flex: 1;
  overflow-y: auto;
}

:deep(.van-index-bar__sidebar) {
  right: 0;
}
</style>
